const diagnostics = {
  faultinfo: {
    historyError: {
      faultTime: "เวลาผิดพลาด",
      starttime: "Start time",
      endtime: "End time",
      faultname: "ชื่อข้อบกพร่อง",
      gbfaultlevel: "Government standard fault level",
      faultlevel: "Fault level",
      faulttype: "Fault type",
      faultcode: "รหัสความผิดปกติ",
      ispopfault: "Whether to push",
      cartype: "Model name",
      batchcode: "Batch lot",
      vcuspareparts: "VCU spare parts",
      mcupareparts: "MCU spare parts",
      level1: "Level1",
      level2: "Level2",
      level3: "Level3",
      level4: "Level4",
      gbfault: "Government standard fault",
      selfdefinedfault: "Self-defined fault",
      allfault: "ความผิดทั้งหมด",
      popfault: "ป๊อปอัปผิดพลาด",
      partname: "Spare parts name",
      createtime: "Create on",
      faultstarttime: "Failure time",
      message1: "Select the vehicle to export",
      searchlabelwidth: {
        width1: "110px",
        width2: "110px",
        width3: "130px",
        width4: "80px"
      },
      tablewidth: {
        vinno: "170",
        licenseplate: "130",
        cartypename: "150",
        batchcode: "130",
        vcuspareparts: "150",
        mcupareparts: "150",
        faultname: "120",
        faultcode: "130",
        faulttype: "140",
        faultlevel: "120",
        gbfaultlevel: "260",
        partname: "150",
        createtime: "140",
        starttime: "180"
      }
    }
  },
  faultcodemanage: {
    faultcode: {
      faultcode: "รหัสความผิดปกติ",
      faultname: "ชื่อความผิดปกติ",
      faultlevel: "ระดับความผิดพลาด",
      brand: "ยี่ห้อ",
      ispopfault: "ไม่ว่าจะดัน",
      all: "ทั้งหมด",
      yes: "ใช่",
      no: "ไม่",
      faulttype: "Fault type",
      gbfault: "Government standard fault",
      selfdefinedfault: "Self-defined fault",
      level1: "ระดับ 1",
      level2: "ระดับ 2",
      level3: "ระดับ 3",
      level4: "ระดับ 4",
      partname: "Spare parts name",
      loginname: "Create by",
      createdon: "สร้างเวลา",
      maintaininfo: "Maintain info",
      solutions: "Solutions",
      message1: "Please select the items you want to edit",
      message2: "Please select the item to delete",
      confirm: "Confirm",
      prompt: "Prompt",
      cancel: "Cancel",
      whethertodelete: "Whether to delete",
      deletesuccessfully: "Successfully delete",
      searchLabelWidth: "100px",
      tablewidth: {
        faulttype: "190",
        faultcode: "120",
        faultname: "180",
        faultlevel: "200",
        faultContent: "230",
        specificBrand: "100",
        ispopfault: "180",
        partname: "160",
        loginname: "100",
        createdon: "150",
        maintaininfo: "150",
        solutions: "120"
      },
      detailFaulcode: "รายละเอียดความผิดปกติ",
      addUpdateDialog: {
        addfaultcode: "เพิ่มรหัสข้อผิดพลาด",
        editfaultcode: "แก้ไขรหัสข้อผิดพลาด",
        faulttype: "Fault type",
        gbfault: "Government Standard fault",
        selfdefinedfault: "Self-defined fault",
        faultcode: "รหัสความผิดปกติ",
        faultlevel: "Fault level",
        partname: "Spare parts name",
        ispopfault: "ไม่ว่าจะดัน",
        gbfaultlevel: "Government standard fault level",
        yes: "ใช่",
        no: "ไม่",
        level1: "ระดับ 1",
        level2: "ระดับ 2",
        level3: "ระดับ 3",
        level4: "ระดับ 4",
        faultname: "ชื่อความผิดปกติ",
        maintaininfo: "Maintain info",
        solutions: "Solutions",
        message1: "โปรดป้อนรหัสข้อผิดพลาด",
        message2: "Please select a fault level",
        message3: "Please select a government standard fault",
        message4: "โปรดป้อนชื่อข้อบกพร่อง",
        message5: "Successfully add",
        message6: "Successfully edit",
        lengthMessage: "ความยาวอักขระต้องไม่เกิน",
        labelWidth: {
          formLeft: "130px",
          formRight: "145px"
        }
      },
      detailWith: {
        width1: "105px",
        width2: "145px"
      }
    }
  }
} 
export default diagnostics